import { configureStore } from "@reduxjs/toolkit";

import selectedNewsieSlice from "./features/selectedNewsie";
import clientProfileSlice from "./features/clientProfileSlice";
import stateSlice from "./features/stateSlice";
import authSlice, {
  loadAuthFromLocalStorage,
  saveAuthToLocalStorage,
} from "./features/authSlice";
import publicPuzzleSlice from "./features/public/publicPuzzleSlice";
import publicStateSlice from "./features/public/publicStateSlice";
import publicUserSlice from "./features/public/publicUserSlice";
import puzzleSlice from "./features/puzzleSlice";

const preloadedState = {
  authSlice: loadAuthFromLocalStorage(),
};

const store = configureStore({
  reducer: {
    selectedNewsieSlice,
    clientProfileSlice,
    stateSlice,
    authSlice,
    publicPuzzleSlice,
    publicStateSlice,
    publicUserSlice,
    puzzleSlice,
  },
  preloadedState,
});

store.subscribe(() => {
  let authState = store.getState().authSlice;
  authState = { ...authState };
  saveAuthToLocalStorage(authState);
});
export default store;
